module.exports = __webpack_public_path__ + "static/img/about_p2_2x.125f223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_p2_2x.png
// module id = FaAs
// module chunks = 1